export default {
  all (context) {
    var params = {
      page: context.page,
      order: context.order
    }
    context.loading = true
    context.$http.get('files', {params: params}).then(response => {
      context.loading = false
      context.files = response.body.data
      context.pagination = response.body.metadata.pagination
    })
  },
  get (context, id) {
    context.$http.get('files/' + id).then(response => {
      context.file = response.body.data[0]
    })
  },
  history (context, id) {
    context.$http.get('files/' + id + '/history').then(response => {
      context.history = response.body.data
    })
  },
  search (context, term, options) {
    return context.$http.post('files/search', {term: term}, options)
  }
}



// WEBPACK FOOTER //
// ./src/services/files.js